import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { languageFormatter } from '../lib/formatter';

const Footer = () => {
  const { i18n } = useTranslation();
  const [ isOpen, setIsOpen ] = useState(false);
  const language = localStorage.getItem('mf_admin_lang') || 'ko';

  const languageItems = [
    { name: '한국어', value: 'ko' },
    { name: 'English', value: 'en' },
  ];

  const changeLanguage = (language) => {
    localStorage.setItem('mf_admin_lang', language);
    i18n.changeLanguage(language);
    // dispatch(configAction.setPageLanguage(language));
  };

  return (
    <Fragment>
      <div className='footer'>
        <Dropdown
          className='p-absolute right-30 w-unset'
          onMouseOver={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
          onClick={e => e.stopPropagation()}
        >
          <Dropdown.Toggle className='br-unset' variant="success" id="dropdown-basic" onClick={e => e.stopPropagation()}>
            <p className='m-0-5 selected-item'>{languageFormatter(language)}</p>
            <FontAwesomeIcon icon={faCaretUp}/>
          </Dropdown.Toggle>
          <Dropdown.Menu show={isOpen}>
            <div className=''>
              {languageItems.map((item, index) => (
                <span
                  key={index}
                  className={`dropdown-lang-item ${language === item.value ? 'selected':''}`}
                  href='#'
                  onClick={() => changeLanguage(item.value)}
                >
                  {item.name}
                </span>
              ))}
            </div>
          </Dropdown.Menu>
        </Dropdown>
        <p className='copyright'>COPYRIGHT ⓒImGATE ALL RIGHTS RESERVED.</p>
      </div>
    </Fragment>
  );
}

export default Footer;